import Container from '@material-ui/core/Container';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import React, { useEffect } from 'react';
import { useViewer } from 'src/hooks/use-viewer';
import FreshworksWidget from '~utils/freshworks-widget';
import { useSideNavigationOpenContext } from './side-navigation-context';
import Slide from './slide';

const useStyles = makeStyles({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    padding: '0 0 0 0',
    minWidth: 768,
    '& > *': {
      width: '100%',
    },
  },
});

const AuthPageLayout = ({ children }) => {
  const classes = useStyles();
  const theme = useTheme();
  const { closeSideNavigation } = useSideNavigationOpenContext();
  const viewer = useViewer();
  const largeMedia = useMediaQuery(`(min-width:${theme.breakpoints.values.lg}px)`);

  useEffect(() => {
    if (!largeMedia) {
      closeSideNavigation();
    }
  }, [closeSideNavigation, largeMedia]);

  useEffect(() => {
    if (viewer) {
      FreshworksWidget(viewer, largeMedia);
    }
  }, [largeMedia, viewer]);

  return (
    <div className={classes.root}>
      <Slide />
      <Container className={classes.content} maxWidth={false}>
        {children}
      </Container>
    </div>
  );
};

export default AuthPageLayout;
